<template>
    <Wrapper>
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4">{{ model.title }}</h1>
                <p class="lead"><T t="media_library.lead" /></p>
            </div>
            <div class="col-span-12 lg:col-span-5 flex lg:justify-end items-center mt-2 lg:mt-0">
                <div class="p-5 bg-white base-responsive-rounding w-full sm:w-auto">
                    <div class="flex items-center mb-4 font-semibold justify-center sm:justify-start">
                        <i class="pi pi-th-large mr-3"></i>
                        <span>{{ model.slides.length }} {{ $tc('media_library.photo', model.slides.length) }}</span>
                        <span class="text-xs mx-2">&bullet;</span>
                        <span>{{ model.media_full_size }}</span>
                    </div>
                    <Button
                        v-if="model.slides.length"
                        :to="model.zip_link"
                        target="_blank"
                        :label="$t('media_library.download_all')"
                        icon="pi pi-download"
                        class="w-full sm:w-auto"
                    />
                </div>
            </div>
        </div>

        <div class="grid grid-cols-12 card-grid-responsive-gap xl:gap-y-14 mt-12">
            <div
                v-for="(image, i) in model.slides"
                :key="`gallery-${i}`"
                class="col-span-12 sm:col-span-6 lg:col-span-3"
            >
                <DownloadImageCard :src="image.src" :img-alt="image.description" :size="image.size" />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import DownloadImageCard from '@/components/Cards/DownloadImageCard/DownloadImageCard.vue';

export default {
    name: 'Gallery',
    components: {
        Wrapper,
        DownloadImageCard,
    },
    async asyncData({ $axios, params, redirect, localePath, i18n }) {
        if (i18n.locale === 'en') {
            return await redirect(307, localePath('magazine'));
        }

        let category = null;
        let model = null;

        await $axios
            .$get(`/gallery-categories/by-slug/${params.gallerycategory}`)
            .then((res) => {
                category = res;
                model = res.galleries.find((x) => x.slug === params.gallery);
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('press'));
        }

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'gallery');

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('press.title'), 'press']);
        breadcrumbItems.push([i18n.t('media_library.title'), 'media-library', true, true]);
        breadcrumbItems.push([category.title, 'gallerycategory']);
        breadcrumbItems.push([model.title, 'gallery']);

        return {
            category,
            model,
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>

<style scoped></style>
